import { useStaticQuery, graphql } from 'gatsby'

import { AfiUTheme } from '@src/types'
import { Nodes } from '@src/types/graphql'

type PartialAfiUTheme = Pick<AfiUTheme, 'id' | 'slug' | 'title' | 'shortDescription'>

export type AfiUThemeHookResult = PartialAfiUTheme[]

export default function useNavigationProgramsTabData() {
  const data = useStaticQuery<{ afiUThemes: Nodes<PartialAfiUTheme> }>(
    graphql`
      {
        afiUThemes: allSanityAfiUTheme(filter: { active: { eq: true } }) {
          nodes {
            id
            slug {
              fr {
                current
              }
              en {
                current
              }
            }
            title {
              fr
              en
            }
            shortDescription {
              fr
              en
            }
          }
        }
      }
    `
  )

  return data.afiUThemes.nodes.sort((a, b) =>
    a.title.fr.localeCompare(b.title.fr)
  ) as AfiUThemeHookResult
}
